import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getConfig, setConfig } from '../../configuracao/configLocal';
import { getConfControladorGrupoList } from './selectdbAtions';

class SelectConfControlador extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: getConfig('cont'),
    };
  }

  componentWillMount() {
    this.props.getConfControladorGrupoList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.list !== this.props.list) {
      this.syncControladorFromList();
    }
  }

  getPrimaryControllers(list) {
    return (list || []).filter(cont => cont.anel === 1);
  }

  selectControlador(cont, notifyParent) {
    if (!cont) {
      return;
    }

    const id = cont.id;
    const prevCont = +getConfig('cont');
    const prevNumCont = +getConfig('numCont');

    setConfig('cont', id);
    setConfig('numCont', cont.numero_controlador);
    setConfig('anel', cont.anel);
    setConfig('contLat', cont.latitude || '');
    setConfig('contLong', cont.longitude || '');

    const configChanged = prevCont !== +id || prevNumCont !== +cont.numero_controlador;

    this.setState({ value: id }, () => {
      if (notifyParent && configChanged && this.props.onChange) {
        this.props.onChange(id);
      }
    });
  }

  syncControladorFromList() {
    if (this.props.anel !== false) {
      return;
    }

    const list = this.props.list || [];
    const configGrupo = getConfig('grupo');

    if (!configGrupo) {
      if (+this.state.value !== 0) {
        this.setState({ value: 0 });
      }
      return;
    }

    if (list.length === 0) {
      return;
    }

    const primary = this.getPrimaryControllers(list);
    if (primary.length === 0) {
      return;
    }

    const currentValue = +this.state.value;
    const selected = primary.find(c => c.id === currentValue);
    const configNumCont = +getConfig('numCont');
    const autoSelect = this.props.autoSelectFirst === true;

    if (selected && configNumCont === 0) {
      this.selectControlador(selected, true);
      return;
    }

    if (currentValue !== 0 && !selected) {
      if (autoSelect) {
        this.selectControlador(primary[0], true);
      } else {
        this.setState({ value: 0 });
        setConfig('cont', 0);
        setConfig('numCont', 0);
        setConfig('anel', 0);
      }
      return;
    }

    if (autoSelect && currentValue === 0 && +getConfig('cont') === 0) {
      this.selectControlador(primary[0], true);
    }
  }

  renderOptions() {
    const list = this.props.list || [];
    const anel = this.props.anel !== false;

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    return list.map(contro => (
      <option
        key={contro.id}
        value={contro.id}
        data-numero={contro.numero_controlador}
        data-anel={contro.anel}
        data-latitude={contro.latitude}
        data-longitude={contro.longitude}
        style={{ display: anel || contro.anel === 1 ? '' : 'none' }}
      >
        {`${contro.numero_controlador} - ${contro.endereco}`}
      </option>
    ));
  }

  handleChange(event) {
    const newValue = event.target.value;

    if (+newValue === 0) {
      const changed = +getConfig('cont') !== 0;
      this.setState({ value: 0 });
      setConfig('cont', 0);
      setConfig('numCont', 0);
      setConfig('anel', 0);
      setConfig('contLat', '');
      setConfig('contLong', '');

      if (changed && this.props.onChange) {
        this.props.onChange(newValue);
      }
      return;
    }

    const changed = +getConfig('cont') !== +newValue;
    this.setState({ value: newValue });
    setConfig('cont', newValue);
    setConfig('numCont', event.target.selectedOptions[0].getAttribute('data-numero'));
    setConfig('anel', event.target.selectedOptions[0].getAttribute('data-anel'));
    setConfig('contLat', event.target.selectedOptions[0].getAttribute('data-latitude'));
    setConfig('contLong', event.target.selectedOptions[0].getAttribute('data-longitude'));

    if (changed && this.props.onChange) {
      this.props.onChange(newValue);
    }
  }

  render() {
    const defaultStyle = { width: '300px', display: 'inline', marginLeft: '8px' };
    const finalStyle = this.props.customStyle ? this.props.customStyle : defaultStyle;

    return (
      <div style={{ marginTop: '0px' }}>
        <select
          id={'selectConfControlador'}
          name={'selectConfControlador'}
          style={finalStyle}
          className={this.props.customStyle ? '' : 'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="0">{this.props.emptyText || 'Selecione...'}</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ list: state.controladorCad.listConf });
const mapDispatchToProps = dispatch => bindActionCreators({ getConfControladorGrupoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectConfControlador);
